// Autogenerated file
export const currencyTypesEnum = {
    RUB: "RUB",
    KZT: "KZT",
    EUR: "EUR",
    USD: "USD",
};
export const currencyTypes = [
    { label: "RUB", value: "RUB" },
    { label: "KZT", value: "KZT" },
    { label: "EUR", value: "EUR" },
    { label: "USD", value: "USD" },
];
